// import ExampleComponent from "./components/ExampleComponent";

import React, { useEffect, useState } from "react";
import Loader from "../common/Loader/Loader";
import { isValidateEmail } from "../../utils/validateEmail";
import { useForm } from "react-hook-form";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getOktaConfig } from "../../oktaConfig";
import { OktaAuth } from "@okta/okta-auth-js";

const LoginForm = ({ onLogin }) => {
    const { instance } = useMsal();
    const {
        formState: { errors, isSubmitting },
    } = useForm();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const { i18n, t } = useTranslation();
    const [email, setEmail] = useState();
    const [error, setError] = useState("");

    useEffect(() => {
        localStorage.setItem("isEntraLogin", false);
    }, []);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // const handleOnSubmit = async (e) => {
    //     setLoading(true);
    //     e.preventDefault();
    //     onLogin(true);
    //     handleOktaLogin(e, false);
    // };

    // Generic Okta login handler for all types
    const handleOktaTypeLogin = (e, type) => {
        setLoading(true);
        e.preventDefault();
        handleOktaLogin(e, type);
        sessionStorage.setItem("oktaConfigType", type);
        onLogin(true);
    };

    const handleDefaultLogin = async (e) => {
        e.preventDefault();
        if(!isValidateEmail(email)) {
        setError(t("invalidEmail")); // <-- use translation here
            return;
        }
        setLoading(true);
        onLogin(false);
        instance.loginRedirect({
            scopes: ["openid", "email", "profile"],
            loginHint: email,
        });
        localStorage.setItem("isEntraLogin", true);
    };

    const handleOktaLogin = (e, type) => {
        e.preventDefault();
        onLogin(true);
        const oktaAuthConfig = getOktaConfig(type);
        const oktaAuthInstance = new OktaAuth(oktaAuthConfig);
        const isUserDocPresent = "userDocInfo" in sessionStorage;
        const isUserSurveyPresent = "userSurveyInfo" in sessionStorage;
        let docurl = "";

        if (isUserDocPresent) {
            const userDocInfo = JSON.parse(
                sessionStorage.getItem("userDocInfo") || "{}"
            );
            docurl =
                "/view-document/" +
                encodeURIComponent(userDocInfo?.userDocument) +
                "?accessibilityLevel=" +
                userDocInfo?.accessibilityLevel;
        } else if (isUserSurveyPresent) {
            const userSurveyInfo = JSON.parse(
                localStorage.getItem("userSurveyInfo") || "{}"
            );
            docurl =
                "/survey/" +
                userSurveyInfo?.surveyId +
                "/" +
                userSurveyInfo?.code +
                "/" +
                userSurveyInfo?.languageId;
        } else {
            docurl = "";
        }
        oktaAuthInstance.signInWithRedirect({
            originalUri: docurl !== "" ? docurl : "/",
            extraParams: {
                login_hint: email,
            },
        });
    };

    return (
    <>   
    { loading && <Loader/>} 
        <div className="svg-container">
                 <svg
                width="100%"
                height="100%"
                viewBox="0 0 605 67" 
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              
            >
                <path
                    d="M594 67L605 52H594L594 67Z"
                    fill="url(#paint0_linear_1132_3056)"
                />
                <path d="M605 52H0V26V0L605 3.8147e-06V52Z" fill="white" />
                <path
                    d="M105.629 25.9692H115.542V38.9233C113.935 39.4474 112.42 39.812 110.996 40.0171C109.583 40.2336 108.136 40.3418 106.655 40.3418C102.884 40.3418 100.001 39.2367 98.0073 37.0264C96.0249 34.8047 95.0337 31.6203 95.0337 27.4731C95.0337 23.4399 96.1844 20.2954 98.4858 18.0396C100.799 15.7837 104 14.6558 108.09 14.6558C110.654 14.6558 113.126 15.1685 115.507 16.1938L113.747 20.4321C111.924 19.5207 110.027 19.0649 108.056 19.0649C105.766 19.0649 103.932 19.834 102.553 21.3721C101.175 22.9102 100.485 24.978 100.485 27.5757C100.485 30.2873 101.038 32.3608 102.143 33.7964C103.26 35.2205 104.877 35.9326 106.997 35.9326C108.102 35.9326 109.224 35.8187 110.363 35.5908V30.3784H105.629V25.9692ZM132.119 19.0649C130.125 19.0649 128.581 19.8169 127.487 21.3208C126.394 22.8133 125.847 24.8983 125.847 27.5757C125.847 33.147 127.937 35.9326 132.119 35.9326C133.873 35.9326 135.998 35.494 138.493 34.6167V39.0601C136.442 39.9146 134.152 40.3418 131.623 40.3418C127.989 40.3418 125.209 39.2424 123.283 37.0435C121.358 34.8332 120.395 31.6659 120.395 27.5415C120.395 24.9438 120.868 22.6709 121.813 20.7227C122.759 18.763 124.115 17.2648 125.881 16.228C127.658 15.1799 129.737 14.6558 132.119 14.6558C134.545 14.6558 136.984 15.2425 139.433 16.416L137.724 20.7227C136.79 20.2783 135.85 19.891 134.904 19.5605C133.959 19.2301 133.03 19.0649 132.119 19.0649ZM149.123 26.7725H150.866C152.495 26.7725 153.715 26.4535 154.523 25.8154C155.332 25.166 155.737 24.2261 155.737 22.9956C155.737 21.7537 155.395 20.8366 154.711 20.2441C154.039 19.6517 152.98 19.3555 151.533 19.3555H149.123V26.7725ZM161.086 22.8076C161.086 25.4964 160.243 27.5529 158.557 28.9771C156.882 30.4012 154.495 31.1133 151.396 31.1133H149.123V40H143.825V15.0146H151.806C154.837 15.0146 157.138 15.6698 158.71 16.98C160.294 18.2788 161.086 20.2214 161.086 22.8076ZM163.701 32.7539V28.4814H172.878V32.7539H163.701ZM186.464 40V15.0146H189.37V37.3682H200.393V40H186.464ZM220.388 30.6177C220.388 33.6711 219.619 36.0579 218.081 37.7783C216.542 39.4873 214.418 40.3418 211.706 40.3418C210.031 40.3418 208.544 39.9487 207.246 39.1626C205.947 38.3765 204.944 37.2485 204.238 35.7788C203.531 34.3091 203.178 32.5887 203.178 30.6177C203.178 27.5643 203.942 25.1888 205.468 23.4912C206.995 21.7822 209.114 20.9277 211.826 20.9277C214.446 20.9277 216.525 21.7993 218.063 23.5425C219.613 25.2856 220.388 27.644 220.388 30.6177ZM206.118 30.6177C206.118 33.0103 206.596 34.8332 207.553 36.0864C208.51 37.3397 209.917 37.9663 211.774 37.9663C213.632 37.9663 215.039 37.3454 215.996 36.1035C216.964 34.8503 217.448 33.0216 217.448 30.6177C217.448 28.2365 216.964 26.4307 215.996 25.2002C215.039 23.9583 213.62 23.3374 211.74 23.3374C209.883 23.3374 208.482 23.9469 207.536 25.166C206.59 26.3851 206.118 28.2023 206.118 30.6177ZM240.708 21.2695V23.064L237.238 23.4741C237.557 23.8729 237.842 24.397 238.093 25.0464C238.343 25.6844 238.469 26.4079 238.469 27.2168C238.469 29.0511 237.842 30.5151 236.589 31.6089C235.336 32.7026 233.615 33.2495 231.428 33.2495C230.869 33.2495 230.345 33.2039 229.855 33.1128C228.648 33.7508 228.044 34.554 228.044 35.5225C228.044 36.0352 228.255 36.4168 228.676 36.6675C229.098 36.9067 229.821 37.0264 230.847 37.0264H234.162C236.19 37.0264 237.745 37.4536 238.828 38.3081C239.921 39.1626 240.468 40.4045 240.468 42.0337C240.468 44.1073 239.637 45.6852 237.973 46.7676C236.31 47.8613 233.883 48.4082 230.693 48.4082C228.243 48.4082 226.352 47.9525 225.019 47.041C223.697 46.1296 223.037 44.8421 223.037 43.1787C223.037 42.0394 223.401 41.0539 224.13 40.2222C224.86 39.3905 225.885 38.8265 227.207 38.5303C226.728 38.3138 226.324 37.9777 225.993 37.522C225.674 37.0662 225.515 36.5365 225.515 35.9326C225.515 35.249 225.697 34.6509 226.062 34.1382C226.426 33.6255 227.001 33.1299 227.788 32.6514C226.819 32.2526 226.027 31.5747 225.412 30.6177C224.808 29.6606 224.506 28.5669 224.506 27.3364C224.506 25.2856 225.122 23.7077 226.352 22.6025C227.583 21.486 229.326 20.9277 231.582 20.9277C232.561 20.9277 233.444 21.0417 234.23 21.2695H240.708ZM225.771 43.1445C225.771 44.1585 226.198 44.9276 227.053 45.4517C227.907 45.9757 229.132 46.2378 230.727 46.2378C233.108 46.2378 234.868 45.8789 236.008 45.1611C237.159 44.4548 237.734 43.492 237.734 42.2729C237.734 41.259 237.421 40.5526 236.794 40.1538C236.167 39.7664 234.988 39.5728 233.256 39.5728H229.855C228.568 39.5728 227.565 39.8804 226.848 40.4956C226.13 41.1108 225.771 41.9938 225.771 43.1445ZM227.309 27.2681C227.309 28.5783 227.679 29.5695 228.42 30.2417C229.16 30.9139 230.192 31.25 231.513 31.25C234.282 31.25 235.666 29.9056 235.666 27.2168C235.666 24.4027 234.265 22.9956 231.462 22.9956C230.129 22.9956 229.104 23.3545 228.386 24.0723C227.668 24.79 227.309 25.8553 227.309 27.2681ZM247.39 40H244.553V21.2695H247.39V40ZM244.313 16.1938C244.313 15.5444 244.473 15.0716 244.792 14.7754C245.111 14.4678 245.51 14.314 245.988 14.314C246.444 14.314 246.837 14.4678 247.167 14.7754C247.498 15.083 247.663 15.5558 247.663 16.1938C247.663 16.8319 247.498 17.3104 247.167 17.6294C246.837 17.937 246.444 18.0908 245.988 18.0908C245.51 18.0908 245.111 17.937 244.792 17.6294C244.473 17.3104 244.313 16.8319 244.313 16.1938ZM266.223 40V27.8833C266.223 26.3566 265.875 25.2173 265.18 24.4653C264.485 23.7134 263.397 23.3374 261.916 23.3374C259.956 23.3374 258.521 23.8672 257.609 24.9268C256.698 25.9863 256.242 27.7352 256.242 30.1733V40H253.405V21.2695H255.712L256.174 23.833H256.311C256.892 22.9102 257.706 22.1981 258.754 21.6968C259.803 21.1841 260.97 20.9277 262.258 20.9277C264.514 20.9277 266.211 21.4746 267.351 22.5684C268.49 23.6507 269.06 25.3882 269.06 27.7808V40H266.223Z"
                    fill="#454647"
                    transform="translate(100, 0)"
                    

                />
                <defs>
                    <linearGradient
                        id="paint0_linear_1132_3056"
                        x1="600.5"
                        y1="58.25"
                        x2="587.111"
                        y2="58.2431"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop />
                        <stop offset="1" stopColor="#05133D" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <form className="login-form">   
            <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "hal")}>{t("singleSignHAL")}</button>
            <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "emea")}>{t("singleSignOnEurope")}</button>
            <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "vantara")}>{t("singleSignVantara")}</button>
            <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "digital")}>{t("singleSignDigital")}</button>
            <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "hds")}>{t("singleSignHDS")}</button>
            {/* <button className="okta-button" onClick={(e) => handleOktaTypeLogin(e, "global")}>{t("singleSignGlobal")}</button>  */}

            <div className="divider">{t("or")}</div>
            <b/>
            <div className="login-form div">
                <input placeholder={t("userNameOrEmail")}
                style={{textAlign: "center"}}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        setError('');
                    }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleDefaultLogin(e); // Trigger login on Enter key press
                        }
                    }}
                    type="text"
                />
                {error && (
                    <div className="error-class">{error}</div>
                )}
                <button
                    className="sign-in-button"
                    disabled={isSubmitting}
                    type="submit"
                    onClick={handleDefaultLogin}
                    
                >
                    {isSubmitting ? "Loading..." : t("signIn")}
                </button>
            </div>
            < br />
            <br />
            <div className="login-form div">
                <div className="link">
                    <a href="mailto:support.cp.jh@hitachi.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                        {t("supEmail")}
                    </a>
                </div>
            </div>
            </form>
        </>
    );
};

export default LoginForm;
